<template>
  <ui-component-modal
    :modalTitle="
      $t('Components.Settings.Invoice.ModalEditInvoiceSettings.Main_Title')
    "
    :onClickSave="saveInvoiceSettings"
    :onClickCancel="onClickCancel"
    :showModal="showModal"
    :disableSaveButton="isLoading"
    :isSaving="isSaving"
    :isSavingSuccess="isSavingSuccess"
    :isSavingError="isSavingError"
    @closeModal="onClickCancel"
  >
    <template v-slot:content>
      <ui-loader v-if="isLoading" />

      <div v-if="settings && !isLoading">
        <div
          class="title is-4"
          v-text="
            $t(
              'Components.Settings.Invoice.ModalEditInvoiceSettings.Title_BasicSettings'
            )
          "
        ></div>
        <table class="table is-fullwidth is-striped">
          <tbody>
            <tr>
              <td>
                {{
                  $t(
                    'Components.Settings.Invoice.ModalEditInvoiceSettings.Label_Code'
                  )
                }}
              </td>
              <td>
                <input type="text" class="input" v-model="mSettings.Code" />
              </td>
            </tr>
            <tr>
              <td>
                {{
                  $t(
                    'Components.Settings.Invoice.ModalEditInvoiceSettings.Label_NumberLength'
                  )
                }}
              </td>
              <td>
                <div class="select">
                  <select v-model="mSettings.NumberLength">
                    <option :selected="mSettings.NumberLength === 0" :value="0"
                      >{{ $t('NotActivated') }}</option
                    >
                    <option :selected="mSettings.NumberLength === 3" :value="3"
                      >3</option
                    >
                    <option :selected="mSettings.NumberLength === 4" :value="4"
                      >4</option
                    >
                    <option :selected="mSettings.NumberLength === 5" :value="5"
                      >5</option
                    >
                  </select>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                {{
                  $t(
                    'Components.Settings.Invoice.ModalEditInvoiceSettings.Label_CodeTemplate'
                  )
                }}
              </td>
              <td>
                <input
                  type="text"
                  class="input"
                  v-model="mSettings.CodeTemplate"
                />
                <div class="has-text-grey is-italic is-size-7">
                  {{
                    $t(
                      'Components.Settings.Invoice.ModalEditInvoiceSettings.Label_Example'
                    )
                  }}
                  {{ codeTemplateExample }}
                </div>
              </td>
            </tr>
            <tr>
              <td>
                {{
                  $t(
                    'Components.Settings.Invoice.ModalEditInvoiceSettings.Label_PaymentTerm'
                  )
                }}
              </td>
              <td>
                <input
                  type="text"
                  class="input"
                  v-model="mSettings.PaymentTerm"
                  placeholder="Number of days"
                />
              </td>
            </tr>
            <tr>
              <td>
                {{
                  $t(
                    'Components.Settings.Invoice.ModalEditInvoiceSettings.Label_PaymentTermFirst'
                  )
                }}
              </td>
              <td>
                <input
                  type="text"
                  class="input"
                  v-model="mSettings.PaymentTermFirstReminder"
                  placeholder="Number of days"
                />
              </td>
            </tr>
            <tr>
              <td>
                {{
                  $t(
                    'Components.Settings.Invoice.ModalEditInvoiceSettings.Label_PaymentTermSecond'
                  )
                }}
              </td>
              <td>
                <input
                  type="text"
                  class="input"
                  v-model="mSettings.PaymentTermSecondReminder"
                  placeholder="Number of days"
                />
              </td>
            </tr>
            <tr>
              <td>
                {{
                  $t(
                    'Components.Settings.Invoice.ModalEditInvoiceSettings.Label_AuthorizationNeeded'
                  )
                }}
              </td>
              <td>
                <div class="control">
                  <label class="radio">
                    <input
                      type="radio"
                      name="status"
                      v-model="mSettings.Status"
                      :value="0"
                      :checked="mSettings.Status === 0"
                    />
                    {{
                      $t(
                        'Components.Settings.Invoice.ModalEditInvoiceSettings.Radio_Yes'
                      )
                    }}
                  </label>
                  <label class="radio">
                    <input
                      type="radio"
                      name="status"
                      v-model="mSettings.Status"
                      :value="1"
                      :checked="mSettings.Status === 1"
                    />
                    {{
                      $t(
                        'Components.Settings.Invoice.ModalEditInvoiceSettings.Radio_No'
                      )
                    }}
                  </label>
                </div>
              </td>
            </tr>
            <tr v-if="mSettings.Status === 0">
              <td>
                {{
                  $t(
                    'Components.Settings.Invoice.ModalEditInvoiceSettings.Label_AllowSelfAuthorization'
                  )
                }}
              </td>
              <td>
                <div class="control">
                  <label class="radio">
                    <input
                      type="radio"
                      name="selfAuthorize"
                      v-model="mSettings.AllowSelfAuthorization"
                      :value="true"
                      :checked="mSettings.AllowSelfAuthorization"
                    />
                    {{
                      $t(
                        'Components.Settings.Invoice.ModalEditInvoiceSettings.Radio_Yes'
                      )
                    }}
                  </label>
                  <label class="radio">
                    <input
                      type="radio"
                      name="selfAuthorize"
                      v-model="mSettings.AllowSelfAuthorization"
                      :value="false"
                      :checked="!mSettings.AllowSelfAuthorization"
                    />
                    {{
                      $t(
                        'Components.Settings.Invoice.ModalEditInvoiceSettings.Radio_No'
                      )
                    }}
                  </label>
                </div>
              </td>
            </tr>
            <tr v-if="mSettings.Status === 0">
              <td>
                {{
                  $t(
                    'Components.Settings.Invoice.ModalEditInvoiceSettings.Label_NoAuthorizationWhenAmountLowerThen'
                  )
                }}
              </td>
              <td>
                <input
                  type="text"
                  class="input"
                  v-model.number="mSettings.NoAuthorizationLowerThen"
                  placeholder="Max amount no authorization needed"
                />
              </td>
            </tr>

            <tr>
              <td>
                {{
                  $t(
                    'Components.Settings.Invoice.ModalEditInvoiceSettings.Label_AutoRemoveUnpaidDeposit'
                  )
                }}
              </td>
              <td>
                <div class="control">
                  <label class="radio">
                    <input
                      type="radio"
                      name="depositCleanup"
                      v-model="mSettings.AutoRemoveUnpaidDeposit"
                      :value="true"
                      :checked="mSettings.AutoRemoveUnpaidDeposit"
                    />
                    {{
                      $t(
                        'Components.Settings.Invoice.ModalEditInvoiceSettings.Radio_Yes'
                      )
                    }}
                  </label>
                  <label class="radio">
                    <input
                      type="radio"
                      name="depositCleanup"
                      v-model="mSettings.AutoRemoveUnpaidDeposit"
                      :value="false"
                      :checked="!mSettings.AutoRemoveUnpaidDeposit"
                    />
                    {{
                      $t(
                        'Components.Settings.Invoice.ModalEditInvoiceSettings.Radio_No'
                      )
                    }}
                  </label>
                </div>
              </td>
            </tr>

            <tr>
              <td>
                {{
                  $t(
                    'Components.Settings.Invoice.ModalEditInvoiceSettings.Label_ShowBasisOnInvoice'
                  )
                }}
              </td>
              <td>
                <div class="control">
                  <label class="radio">
                    <input
                      type="radio"
                      name="showBasisOnInvoice"
                      v-model="mSettings.ShowBasisOnInvoice"
                      :value="true"
                      :checked="mSettings.ShowBasisOnInvoice"
                    />
                    {{
                      $t(
                        'Components.Settings.Invoice.ModalEditInvoiceSettings.Radio_Yes'
                      )
                    }}
                  </label>
                  <label class="radio">
                    <input
                      type="radio"
                      name="showBasisOnInvoice"
                      v-model="mSettings.ShowBasisOnInvoice"
                      :value="false"
                      :checked="!mSettings.ShowBasisOnInvoice"
                    />
                    {{
                      $t(
                        'Components.Settings.Invoice.ModalEditInvoiceSettings.Radio_No'
                      )
                    }}
                  </label>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <div
          class="title is-4"
          v-text="
            $t(
              'Components.Settings.Invoice.ModalEditInvoiceSettings.Title_EmailSettings'
            )
          "
        ></div>
        <table class="table is-fullwidth is-striped">
          <tbody>
            <tr>
              <td>
                {{
                  $t(
                    'Components.Settings.Invoice.ModalEditInvoiceSettings.Label_DefaultSenderEmailAddress'
                  )
                }}
              </td>
              <td>
                <input
                  type="text"
                  class="input"
                  v-model="mSettings.DefaultSenderAddress"
                  placeholder="Email address"
                />
              </td>
            </tr>
            <tr>
              <td>
                {{
                  $t(
                    'Components.Settings.Invoice.ModalEditInvoiceSettings.Label_AutoCC'
                  )
                }}
              </td>
              <td>
                <input
                  type="text"
                  class="input"
                  v-model="mSettings.AutoCC"
                  placeholder="Email address"
                />
              </td>
            </tr>
            <tr>
              <td>
                {{
                  $t(
                    'Components.Settings.Invoice.ModalEditInvoiceSettings.Label_AutoSendAfterAcceptInvoice'
                  )
                }}
              </td>
              <td>
                <label class="radio">
                  <input
                    type="radio"
                    name="emailAfterAccept"
                    v-model="mSettings.AutoEmailAfterAccept"
                    :value="true"
                    :checked="mSettings.AutoEmailAfterAccept"
                  />
                  {{
                    $t(
                      'Components.Settings.Invoice.ModalEditInvoiceSettings.Radio_Yes'
                    )
                  }}
                </label>
                <label class="radio">
                  <input
                    type="radio"
                    name="emailAfterAccept"
                    v-model="mSettings.AutoEmailAfterAccept"
                    :value="false"
                    :checked="!mSettings.AutoEmailAfterAccept"
                  />
                  {{
                    $t(
                      'Components.Settings.Invoice.ModalEditInvoiceSettings.Radio_No'
                    )
                  }}
                </label>
              </td>
            </tr>
            <tr>
              <td>
                {{
                  $t(
                    'Components.Settings.Invoice.ModalEditInvoiceSettings.Label_AutoSendAfterCreditInvoice'
                  )
                }}
              </td>
              <td>
                <label class="radio">
                  <input
                    type="radio"
                    name="emailAfterCredit"
                    v-model="mSettings.AutoEmailAfterCredit"
                    :value="true"
                    :checked="mSettings.AutoEmailAfterCredit"
                  />
                  {{
                    $t(
                      'Components.Settings.Invoice.ModalEditInvoiceSettings.Radio_Yes'
                    )
                  }}
                </label>
                <label class="radio">
                  <input
                    type="radio"
                    name="emailAfterCredit"
                    v-model="mSettings.AutoEmailAfterCredit"
                    :value="false"
                    :checked="!mSettings.AutoEmailAfterCredit"
                  />
                  {{
                    $t(
                      'Components.Settings.Invoice.ModalEditInvoiceSettings.Radio_No'
                    )
                  }}
                </label>
              </td>
            </tr>

            <tr>
              <td>
                {{
                  $t(
                    'Components.Settings.Invoice.ModalEditInvoiceSettings.Label_AutoSendFirstReminder'
                  )
                }}
              </td>
              <td>
                <label class="radio">
                  <input
                    type="radio"
                    name="emailSendFirstReminder"
                    v-model="mSettings.AutoEmailFirstReminder"
                    :value="true"
                    :checked="mSettings.AutoEmailFirstReminder"
                  />
                  {{
                    $t(
                      'Components.Settings.Invoice.ModalEditInvoiceSettings.Radio_Yes'
                    )
                  }}
                </label>
                <label class="radio">
                  <input
                    type="radio"
                    name="emailSendFirstReminder"
                    v-model="mSettings.AutoEmailFirstReminder"
                    :value="false"
                    :checked="!mSettings.AutoEmailFirstReminder"
                  />
                  {{
                    $t(
                      'Components.Settings.Invoice.ModalEditInvoiceSettings.Radio_No'
                    )
                  }}
                </label>
              </td>
            </tr>

            <tr>
              <td>
                {{
                  $t(
                    'Components.Settings.Invoice.ModalEditInvoiceSettings.Label_AutoSendSecondReminder'
                  )
                }}
              </td>
              <td>
                <label class="radio">
                  <input
                    type="radio"
                    name="emailSendSecondReminder"
                    v-model="mSettings.AutoEmailSecondReminder"
                    :value="true"
                    :checked="mSettings.AutoEmailSecondReminder"
                  />
                  {{
                    $t(
                      'Components.Settings.Invoice.ModalEditInvoiceSettings.Radio_Yes'
                    )
                  }}
                </label>
                <label class="radio">
                  <input
                    type="radio"
                    name="emailSendSecondReminder"
                    v-model="mSettings.AutoEmailSecondReminder"
                    :value="false"
                    :checked="!mSettings.AutoEmailSecondReminder"
                  />
                  {{
                    $t(
                      'Components.Settings.Invoice.ModalEditInvoiceSettings.Radio_No'
                    )
                  }}
                </label>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
  </ui-component-modal>
</template>

<script>
import BaseInvoiceSettingsFunctions from '@/components/Settings/Invoice/BaseInvoiceSettingsFunctions.js'
import invoiceProvider from '@/providers/invoice'
import { mapMutations } from 'vuex'

export default {
  extends: BaseInvoiceSettingsFunctions,

  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    onClickCancel: {
      type: Function,
      required: true,
    },
    settings: {
      default: null,
      type: Object,
    },
  },

  data() {
    return {
      locationId: Number(this.$route.params.locationId),
      mSettings: this.$objectHelper.cleanSource(this.settings),
      isSavingSuccess: false,
      isSavingError: false,
      isSaving: false,
    }
  },

  computed: {
    codeTemplateExample() {
      return this.getCode(
        99,
        this.mSettings.NumberLength,
        this.mSettings.CodeTemplate,
        this.mSettings.Code
      )
    },
  },

  created() {
    let self = this
    if (!this.mSettings) {
      this.getLocationInvoiceSettings((response) => {
        self.mSettings = response
      })
    } else {
      this.isLoading = false
    }
  },

  methods: {
    ...mapMutations('invoiceStore', ['setInvoiceSettings']),

    async saveInvoiceSettings() {
      let self = this
      if (!this.isSaving) {
        self.isSaving = true
        await invoiceProvider.methods
          .updateLocationInvoiceSettings(this.mSettings)
          .then((response) => {
            if (response.status === 204) {
              //self.mSettings = settings
              self.isSavingSuccess = true
              self.setInvoiceSettings(this.mSettings)

              let t = setTimeout(() => {
                self.$emit('updateInvoiceSettings', this.mSettings)
                self.onClickCancel()
                clearTimeout(t)
              }, 1500)
            }
          })
          .catch((error) => {
            //console.log(error.response)
            self.isSavingError = true
          })
      }
    },
  },
}
</script>
